import { graphql } from "relay-runtime"

export const chUpdateAllPatientConditionsMutation = graphql`
  mutation chUpdateAllPatientConditionsMutation($input: Ch_updateAllPatientConditionsInput!) {
    updateAllPatientConditions: ch_updateAllPatientConditions(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on IcdCodeNotUnique {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      patientConditionInformationOutput {
        id
        status
        conditions {
          comment
          icdDiagnosis {
            id
            isAssociation
            diagnosisCode
            primaryCode
            secondaryCode
            associationType
            text
          }
        }
      }
    }
  }
`
